import { supabase } from "@/integrations/supabase/client";

const SESSION_KEY = "rym_session_id";

function getSessionId(): string {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

function getUtmParams(): Record<string, string | null> {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_term: params.get("utm_term"),
    utm_content: params.get("utm_content"),
  };
}

export async function trackPageVisit(pagePath: string) {
  try {
    const session_id = getSessionId();
    const utm = getUtmParams();

    await supabase.functions.invoke("track-visit", {
      body: {
        page_path: pagePath,
        referrer: document.referrer || null,
        session_id,
        user_agent: navigator.userAgent,
        ...utm,
      },
    });
  } catch (e) {
    // Silent fail - never block the UI
    console.debug("[tracking] failed:", e);
  }
}
